__webpack_require__.p = "/Data-Sci-Portfolios/";